import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { InternalTransferIneligibleContent } from '@src/app/shared/services/content/content-jsons/internal-transfer-ineligible-content';

import { getConfigClientFromRTE } from '../../../../core/config/config-client';
import {
  ClearStateAndStorage,
  closeSpinner,
  TrackCallToAction,
  TrackProcessSideStep,
} from '../../../../core/store';
import * as fromRootStore from '../../../../core/store';
import { PageComponent } from '../../../../shared/components/page/page.component';
import { ContentPageId } from '../../../../shared/models/content-page-ids';
import { LoggerCodes, LoggerService } from '../../../../shared/modules/logger/logger';
import { WindowRef } from '../../../../shared/modules/window-ref/window-ref';

@Component({
  selector: 'app-internal-transfer-ineligible',
  templateUrl: './internal-transfer-ineligible.component.html',
  styleUrls: ['./internal-transfer-ineligible.component.scss'],
})
export class InternalTransferIneligibleComponent
  extends PageComponent
  implements OnInit, OnDestroy
{
  config: any;
  content = InternalTransferIneligibleContent;

  constructor(
    globalStore: Store<fromRootStore.State>,
    protected loggerService: LoggerService,
    private windowRef: WindowRef,
  ) {
    super(ContentPageId.ineligible, globalStore);
    loggerService.info(
      { eventId: 'page-load', message: 'InternalTransferIneligible.Load' },
      LoggerCodes.GENERAL_SUCCESS,
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.globalStore.dispatch(ClearStateAndStorage());

    this.adobeIneligible();
    this.config = getConfigClientFromRTE();
    this.globalStore.dispatch(closeSpinner());
  }

  learnMore() {
    this.adobeTrackButtonClick();
    this.windowRef.nativeWindow.location.href = this.config.balances_url;
  }

  adobeTrackButtonClick() {
    const data = {
      location: `coo-internal_transfer-ineligible`,
      ctaName: `coo-internal_transfer`,
      ctaType: 'button',
    };
    this.globalStore.dispatch(TrackCallToAction(data));
  }

  adobeIneligible() {
    this.globalStore.dispatch(
      TrackProcessSideStep({
        processType: `coo-internal_transfer-flow`,
        processSideStep: `coo-internal_transfer-ineligible`,
      }),
    );
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
